// エルマーの製品タイプ
export const ELMER_PRODUCT_TYPE_NAME = {
  ADVANCED: 'ADVANCED',
  STANDARD: 'STANDARD',
} as const;

type ELMER_PRODUCT_TYPE_NAME =
  typeof ELMER_PRODUCT_TYPE_NAME[keyof typeof ELMER_PRODUCT_TYPE_NAME];

/**
 * エルマーの製品タイプを返す
 * @returns 製品タイプ
 */
const elmerProductType = (): string => {
  const pathNames = window.location.pathname.split('/');
  // パスなければ、とりあえずADVANCEDを返す
  if (pathNames.length < 2) {
    return ELMER_PRODUCT_TYPE_NAME.ADVANCED;
  }

  const firstPathName = pathNames[1];
  switch (firstPathName) {
    case 'adv':
      return ELMER_PRODUCT_TYPE_NAME.ADVANCED;
    case 'std':
      return ELMER_PRODUCT_TYPE_NAME.STANDARD;
    default:
      return ELMER_PRODUCT_TYPE_NAME.ADVANCED;
  }
};

export default elmerProductType;
